<template>
  <div>
    <donation-step-flow-v1-component
      v-if="!useUpdatedDonationFlow"
      :defined-step="definedStep ? Number(definedStep) : null"
      :multiple-donation-types="multipleDonationTypes"
      :request-has-external-agent="requestHasExternalAgent"
      :request-has-only-one-case="requestHasOnlyOneCase"
      :request-has-organization-group="requestHasOrganizationGroup"
      :stepper-ready="stepperReady"
    />
    <donation-step-flow-v2-component
      v-else
      :defined-step="definedStep ? Number(definedStep) : null"
      :multiple-donation-types="multipleDonationTypes"
      :request-has-external-agent="requestHasExternalAgent"
      :request-has-only-one-case="requestHasOnlyOneCase"
      :request-has-organization-group="requestHasOrganizationGroup"
      :stepper-ready="stepperReady"
    />
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';
import { DonationGuideVersion } from '@/enums/donationGuideVersion';
import DonationStepFlowV1Component from './DonationStepFlowV1Component.vue';
import DonationStepFlowV2Component from './DonationStepFlowV2Component.vue';

const store = useStore();

const useUpdatedDonationFlow = computed(() => {
  return store.state.donationGuideVersion === DonationGuideVersion.V2;
});

defineProps<{
  definedStep?: number | string | null;
  multipleDonationTypes?: boolean;
  requestHasExternalAgent?: boolean;
  requestHasOnlyOneCase?: boolean;
  requestHasOrganizationGroup?: boolean;
  stepperReady?: boolean;
}>();
</script>
